import { useEffect } from "react"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import useAuthContext from "../components/context/AuthContext"
import { mergeUnique } from "../lib/array"
import { getDefaultTicketFields, getDefaultTicketFieldsForView } from "../lib/ticket"
import { getTicketField, getTicketFields } from "../repositories/ticketFieldRepo"
import ticketLayoutState from "../state/layoutState"
import { customFieldsState, ticketFieldState } from "../state/selectors/fieldSelectors"
import ticketDataFieldListState from "../state/ticketDataFieldListState"
import ticketFieldListState from "../state/ticketFieldListState"


export const useTicketFields = () => {
  const [ticketFields, setTicketFields] = useRecoilState(ticketFieldListState);
  const { currentShop } = useAuthContext();
  const defaults = getDefaultTicketFields()
  useEffect(() => {
    if(!currentShop || !defaults) return
    getTicketFields(currentShop.id).then((ticketFields) => {
      setTicketFields([...ticketFields, ...defaults])
    })
  }, [currentShop])
  return ticketFields
}

export const useTicketFieldsForView = () => {
  const [ticketFields, setTicketFields] = useRecoilState(ticketFieldListState);
  const { currentShop } = useAuthContext();
  useEffect(() => {
    if(!currentShop) return
    getTicketFields(currentShop?.id).then((ticketFields) => {
      const defaults = getDefaultTicketFieldsForView()
      setTicketFields([...ticketFields, ...defaults])
    })
  }, [currentShop])

  return ticketFields
}

export const useTicketDataFields = () => {
  const [ticketFields, setTicketFields] = useRecoilState(ticketDataFieldListState);
  const { currentShop } = useAuthContext();
  useEffect(() => {
    if(!currentShop) return
    getTicketFields(currentShop?.id).then((ticketFields) => {
      const defaults = getDefaultTicketFieldsForView()
      setTicketFields([...ticketFields, ...defaults])
    })
  }, [currentShop])

  return ticketFields
}

export const useSelectableFields = () => {
  const [ticketFields, setTicketFields] = useRecoilState(ticketFieldListState);
  const [ticketLayout, setTicketLayout] = useRecoilState(ticketLayoutState)

  return ticketFields?.filter((field) => {
    return !ticketLayout?.fieldCodes?.includes(field.code)
  })
}

export const useCustomTicketFields = () => {
  const ticketFields = useRecoilValue(customFieldsState);
  const setTicketFields = useSetRecoilState(ticketFieldListState)
  const { currentShop } = useAuthContext();
  useEffect(() => {
    if(!currentShop) return
    getTicketFields(currentShop?.id).then((customTicketFields) => {
      const merged = mergeUnique(ticketFields, customTicketFields)
      setTicketFields(merged)
    });
  }, [currentShop])

  return ticketFields
}

export const useTicketField = (fieldId: string) => {
  const ticketField = useRecoilValue(ticketFieldState(fieldId))
  const [ticketFields, setTicketFields] = useRecoilState(ticketFieldListState);
  const setTicketFieldState = (field) => {
    setTicketFields(mergeUnique(ticketFields, [field]))
  }
  const { currentShop } = useAuthContext();
  useEffect(() => {
    if(!currentShop || !fieldId) return
    getTicketField(currentShop?.id, fieldId).then((ticketField) => {
      if (ticketFields.find((_field) => ticketField && _field.id == ticketField.id)) return
      setTicketFields([...ticketFields, ticketField])
    });
  }, [currentShop, fieldId])

  return {ticketField, setTicketFieldState}
}